
import React from 'react';
import { GeneralChartComponentProps } from './types';
import { CHART_TYPE_INFO } from './constants';

export const GeneralChartComponent: React.FC<GeneralChartComponentProps> = (props) => {
    const {
        data,
        chartProps,
        type
    } = props;
    const ChartComponent = CHART_TYPE_INFO[type];
    return(
        <ChartComponent
            data={data}
            chartProps={chartProps}
        />
    );
};
export default GeneralChartComponent;
